import { useState } from 'react'
import { CampaignsList } from './campaigns-list'
import { CampaignDetail } from './campaign-detail'

type View = { type: 'list' } | { type: 'detail'; campaignId: string }

export function CampaignsPage() {
  const [view, setView] = useState<View>({ type: 'list' })

  function handleViewDetails(id: string) {
    setView({ type: 'detail', campaignId: id })
  }

  function handleBack() {
    setView({ type: 'list' })
  }

  if (view.type === 'detail') {
    return (
      <div className="p-6">
        <CampaignDetail campaignId={view.campaignId} onBack={handleBack} />
      </div>
    )
  }

  return (
    <div className="p-6">
      <CampaignsList onViewDetails={handleViewDetails} />
    </div>
  )
}
